import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import TextEditor from "../../biztran_controls/TextEditor";

const CreateEmailTemp = (props) => {
    const [TemplateName, setTemplateName] = useState('');
    const [Subject, setSubject] = useState('');
    const [EmailBody, setEmailBody] = useState('');
    const [DtlsData, setDtlsData] = useState();
    const [response, fetchData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();

    const validationSchema = Yup.object({
        TemplateName: Yup.string().required('Required!'),
        Subject: Yup.string().required('Required!'),
        //EmailBody:Yup.string().required('Required!'),
    });

    const onSubmit = values => {
        //console.log(values);
        // debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'EmailTemplate');
        bodyFormData.append("PKID", props.PKID);
        bodyFormData.append("Value1", values.TemplateName);
        bodyFormData.append("Value2", values.Subject);
        bodyFormData.append("Value3", EmailBody);
        fetchData("Primary/Save", bodyFormData);
    };

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'EmailTemplate');
        bodyFormData.append("PKID", props.PKID);
        fetchGetData("Primary/GetByID", bodyFormData);
    }

    useEffect(() => {
        if (response.Response === true) {
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if (response.Response === false) {
            alert('Save Failed.')
        }
    }, [response]);

    useEffect(() => {
        if (responseGetData.length > 0) {
            setTemplateName(responseGetData[0].TemplateName);
            setSubject(responseGetData[0].Subject);
            setEmailBody(responseGetData[0].EmailBody);
        }
    }, [responseGetData])

    useEffect(() => {
        if (props.PKID !== '') {
            getByIDData();
        }
    }, [])

    return (
        <div>
            <Formik initialValues={{ TemplateName: TemplateName, Subject: Subject, EmailBody: EmailBody }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Template Name'
                                    name='TemplateName'
                                    onChange={(e) => setTemplateName(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Subject'
                                    name='Subject'
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {/* <BiztranControlsFormik 
                                    control="textarea"
                                    type="text" 
                                    label='Template Body'
                                    name='EmailBody' 
                                    onChange={(e) => setEmailBody(e.target.value)}
                                /> */}
                                <TextEditor
                                    setDtlsData={setDtlsData}
                                    EMailBody={EmailBody}
                                    setEMailBody={setEmailBody}
                                    name='EmailBody'
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default CreateEmailTemp;
